import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import searchService from '../services/searchService';

export const search = createAsyncThunk('search/get', async (query) => {
  const results = await searchService.search(query);

  return results;
});

const INITIAL_STATE = {
  pendingQuery: '',
  resultsQuery: '',
  active: [],
  other: [],
  superOrg: [],
  isLoading: false,
  isError: false
};

const searchSlice = createSlice({
  name: 'search',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(search.fulfilled, (state, action) => {
        const query = action.meta.arg;

        if (query === state.pendingQuery) {
          state.resultsQuery = query;
          state.active = action.payload.active;
          state.other = action.payload.other;
          state.superOrg = action.payload.super_org;
          state.isLoading = false;
          state.isError = false;
        }
      })
      .addCase(search.pending, (state, action) => {
        const query = action.meta.arg;

        state.pendingQuery = query;
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(search.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase('signOutGlobally', () => ({ ...INITIAL_STATE }));
  }
});

export default searchSlice.reducer;
